<template>
    <div class="fhv-centent" v-loading="loading">
        <h4 class="title-topic">DDNS Settings</h4>
        <el-form :model="ddnsForm" 
            :rules="checkForm"
            ref="ddnsForm"
            label-width="180px" 
            label-position="left"
            class="fhv-form" 
            size="mini"
            :disabled="$G_DEVICE_CFG.isReadOnly"
            >
            <el-form-item label="Enable DDNS:" prop="ddnsEnable">
                <el-switch v-model="ddnsForm.ddnsEnable" @change="setDdnsEnable"></el-switch>
            </el-form-item>
            <div v-if="ddnsForm.ddnsEnable">
                <el-form-item label="Service Provider:" prop="ddnsType">
                    <el-select v-model="ddnsForm.ddnsType" placeholder="Please select" style="width: 100%">
                        <el-option v-for="item in ddnsTypeList" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="Others Service Provider:" prop="ddnsOtherUrl" v-if=" ddnsForm.ddnsType === 4">
                    <el-input v-model="ddnsForm.ddnsOtherUrl"></el-input>
                </el-form-item>
                <el-form-item label="Domain Name:" prop="ddnsDomanin">
                    <el-input v-model="ddnsForm.ddnsDomanin"></el-input>
                </el-form-item>
                <el-form-item label="User Name/Email:" prop="ddnsName">
                    <el-input v-model="ddnsForm.ddnsName"></el-input>
                </el-form-item>
                <el-form-item label="Password/Key:" prop="ddnsPassword">
                    <el-input v-model="ddnsForm.ddnsPassword" type="password"></el-input>
                </el-form-item>
                <el-form-item label="">
                    <el-button type="primary" @click="apply" >Apply</el-button>
                    <el-button type="primary" @click="getDdns">Refresh</el-button>
                </el-form-item>
            </div>
        </el-form>
        <div v-if="ddnsForm.ddnsEnable">
            <h4 class="title-topic">DDNS Status</h4>
            <el-table :data="ddnsStatusTab" border style="width: 100%" size="mini">
            <el-table-column prop="ddnsDomanin" label="Domain Name"></el-table-column>
            <el-table-column prop="ddnsName" label="User Name/Email"></el-table-column>
            <el-table-column prop="ddnsStatus" label="DDNS Status"></el-table-column>
            <el-table-column label="DDNS Test" >
                <template slot-scope="scope">
                    <el-button
                    type="primary"
                    size="mini"
                    :disabled="$G_DEVICE_CFG.isReadOnly"
                    @click="testDdns(scope.$index, scope.row)">test</el-button>
                </template>
            </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
    const _ddnsTypeList = [
        { label: "DynDNS", value: 0 },
        { label: "TZO", value: 1 },
        { label: "oray.com", value: 2 },
        { label: "No-IP.com", value: 3 },
        { label: "Others", value: 4 }
    ]
    export default {
        data() {
            return {
                loading: false,
                ddnsStatusTab:[],
                ddnsForm:{
                    ddnsEnable:false,
                    ddnsType:0,
                    ddnsDomanin:'',
                    ddnsName:'',
                    ddnsPassword:'',
                    ddnsOtherUrl:'',
                },
                ddnsTypeList:_ddnsTypeList,
                checkForm:{
                    ddnsDomanin:[
                        { required: true,min:1,max:51, message: 'Domain Name cannot be empty and must be less than 51-bit', trigger: 'blur' },
                    ],
                    ddnsName:[
                        { required: true,min:1,max:51, message: 'User Name/Email cannot be empty and must be less than 51-bit', trigger: 'blur' },
                    ],
                    ddnsPassword:[
                        { required: true,min:1,max:51, message: 'Password/Key cannot be empty and must be less than 51-bit', trigger: 'blur' },
                    ],
                    ddnsOtherUrl:[
                        { required: true,min:1,max:51, message: 'Others Service Provider cannot be empty and must be less than 51-bit', trigger: 'blur' },
                    ]
                }
            }
        },
        created(){
            this.getDdns()
        },
        methods: {
            getDdns(){
                this.loading = true
                axios
                .post("/JSONAPI",{cmdType:"GET_DDNS"})
                .then((response)=>{
                    this.loading = false
                    if(response.data.ret === 0)
                    {
                        this.ddnsStatusTab = []
                        
                        if(response.data.ddnsEnable)
                        {
                            let srcDdns = response.data
                            srcDdns.ddnsStatus = ''
                            this.ddnsStatusTab.push(srcDdns)
                        }
                        
                        this.ddnsForm.ddnsEnable = response.data.ddnsEnable
                        this.ddnsForm.ddnsType = response.data.ddnsType
                        this.ddnsForm.ddnsDomanin = response.data.ddnsDomanin
                        this.ddnsForm.ddnsName = response.data.ddnsName
                        this.ddnsForm.ddnsPassword = response.data.ddnsPassword
                        this.ddnsForm.ddnsOtherUrl = response.data.ddnsOtherUrl
                    }
                    else
                        this.$message.error(`GET data failed!Error:${response.data.errMsg}`)
                })
                .catch((error) => {
                    this.loading = false
                    this.$message.error('GET data failed! Network connection error!')
                })
            },
            setDdns(){
                this.loading = true
                axios
                .post("/JSONAPI",{
                    cmdType:"SET_DDNS",
                    ddnsType:this.ddnsForm.ddnsType,
                    ddnsDomanin:this.ddnsForm.ddnsDomanin,
                    ddnsName:this.ddnsForm.ddnsName,
                    ddnsPassword:this.ddnsForm.ddnsPassword,
                    ddnsOtherUrl:this.ddnsForm.ddnsOtherUrl,
                })
                .then((response)=>{
                    this.loading = false
                    if(response.data.ret === 0)
                    {
                        this.$message.success('Configuration is success!')
                        this.getDdns()
                    }
                    else
                    this.$message.error(`Configuration failed! Error:${response.data.errMsg}`)
                })
                .catch((error) => {
                    this.loading = false
                    this.$message.error('SET ddns failed! Network connection error!')
                })
            },
            setDdnsEnable(value){
                this.loading = true
                axios
                .post("/JSONAPI",{
                    cmdType:"SET_DDNS_ENABLE",
                    ddnsEnable:value
                })
                .then((response)=>{
                    this.loading = false
                    if(response.data.ret === 0)
                    {
                        this.$message.success('Configuration is success!')
                    }
                    else
                    this.$message.error(`Configuration failed! Error:${response.data.errMsg}`)
                })
                .catch((error) => {
                    this.loading = false
                    this.$message.error('SET ddns failed! Network connection error!')
                })
            },
            testDdns(index, row){
                this.loading = true
                axios
                .post("/JSONAPI",{
                    cmdType:"GET_DDNS_STATUS"
                })
                .then((response)=>{
                    this.loading = false
                    if(response.data.ret === 0)
                    {
                        this.ddnsStatusTab[0].ddnsStatus = response.data.ddnsStatus
                    }
                    else
                        this.$message.error(`Test DDNS status failed! Error:${response.data.errMsg}`)
                })
                .catch((error) => {
                    this.loading = false
                    this.$message.error('Test DDNS status failed! Network connection error!')
                })
            },
            apply() {
                this.$refs['ddnsForm'].validate((valid) => {
                    if (valid) {
                        this.setDdns()
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                })
            },
        },
    }
</script>
